// extracted by css-extract-rspack-plugin
export default {"root":"Ryahu","label":"Npz1m","remove":"VKiaS"};